import React from "react";

const ViewOrderModal = ({ isOpen, onClose, order }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 overflow-auto">
      <div className="bg-gray-900 text-white w-full max-w-4xl rounded-lg shadow-lg p-6">
        <header className="flex justify-between items-start mb-6">
          <div>
            <h1 className="text-2xl font-bold">Pedido {order.id}</h1>
            <p className="text-gray-400">Realizado el {order.date}</p>
          </div>
          <button
            className="text-gray-400 hover:text-white"
            onClick={onClose}
          >
            ✕
          </button>
        </header>

        <section className="mb-6">
          <h3 className="text-xl font-bold mb-4">Resumen del Pedido</h3>
          <table className="w-full text-sm text-gray-400">
            <thead>
              <tr className="border-b border-gray-800">
                <th className="text-left pb-2">Producto</th>
                <th className="text-left pb-2">Color</th>
                <th className="text-left pb-2">Talla</th>
                <th className="text-center pb-2">Cantidad</th>
                <th className="text-right pb-2">Precio Unitario</th>
                <th className="text-right pb-2">Subtotal</th>
              </tr>
            </thead>
            <tbody>
              {order.products.map((p, idx) => (
                <tr key={idx} className="border-b border-gray-800">
                  <td className="py-2">{p.name}</td>
                  <td className="py-2">{p.color || "-"}</td>
                  <td className="py-2">{p.size || "-"}</td>
                  <td className="text-center">{p.qty}</td>
                  <td className="text-right">${p.price.toFixed(2)}</td>
                  <td className="text-right">${(p.price * p.qty).toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr className="border-t-2 border-gray-800">
                <td colSpan={5} className="text-right font-bold pt-4">Total</td>
                <td className="text-right font-bold pt-4">${order.products.reduce((sum, p) => sum + p.price * p.qty, 0).toFixed(2)}</td>
              </tr>
            </tfoot>
          </table>
        </section>

        <section className="mb-6">
          <h3 className="text-xl font-bold mb-2">Información del Cliente</h3>
          <p><span className="text-gray-400">Nombre: </span>{order.customer}</p>
          <p><span className="text-gray-400">Dirección: </span>{order.address || "No especificada"}</p>
          <p><span className="text-gray-400">Correo: </span>{order.email || "No especificado"}</p>
        </section>

        <section className="flex justify-end gap-2">
          <button className="bg-gray-800 hover:bg-gray-700 px-4 py-2 rounded" onClick={onClose}>Cerrar</button>
        </section>
      </div>
    </div>
  );
};

export default ViewOrderModal;
